import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import BusinessGoal from "../../Data/BusinessGoal";
import jwt_decode from "jwt-decode";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { Helmet } from "react-helmet-async";
import RadioInput from "../../Components/RadioInput/RadioInput";
import { withRouter } from "react-router-dom";
import "./Goal.css";

class Goal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      showButton: false,
      isLoading: true,
    };

    this.handleRadioInputOnChange = this.handleRadioInputOnChange.bind(this);
    this.handleMatchingCriteria5 = this.handleMatchingCriteria5.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (
        this.props.location.state === undefined ||
        !this.props.location.state.userData ||
        !this.props.location.state.userData.matching_criteria
      ) {
        if (!decoded.active) {
          this.props.history.push("/");
        } else {
          this.props.history.push("/dashboard");
        }
      } else {
        let userData = this.props.location.state.userData;
        if (!decoded.active) {
          this.props.history.push("/payment", { userData: userData });
        } else {
          const { match_comparable_revenues } = userData.matching_criteria;
          if (!match_comparable_revenues) {
            this.props.history.push("/matching-criteria-4", {
              userData: userData,
            });
          } else {
            if (this.props.matching_criteria_5 !== "") {
              this.setState({
                value: this.props.matching_criteria_5,
                isLoading: false,
              });
            } else {
              this.setState({
                isLoading: false,
              });
            }
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value && this.state.value !== "") {
      this.setState({
        showButton: true,
      });
    }
  }

  handleRadioInputOnChange(value) {
    this.props.setMatchingCriteria5(value);
    this.setState({
      value: value,
    });
  }

  handleMatchingCriteria5() {
    let value = this.state.value;
    let userData = this.props.location.state.userData;
    this.props.history.push("/matching-criteria-6", {
      userData: {
        ...userData,
        matching_criteria: {
          ...userData.matching_criteria,
          nearest_business_goal: value,
        },
      },
    });
  }

  handleBackButtonClick() {
    this.props.history.goBack();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-matching-criteria-5"
          hasCounter={true}
          step="5"
          hasQuote={true}
          quote="What's the thing you are most focused on right now and other founders could help you with or hold you accountable to achieve?"
          headerText="What's your nearest-term business goal?"
          primaryButtonText="Next step"
          hasSkip={false}
          handlePrimaryBtnOnClick={this.handleMatchingCriteria5}
          activatePrimaryWithEnter={true}
          showButton={this.state.showButton}
          showBackButton={true}
          backButtonText="Back"
          handleBackButtonClick={this.handleBackButtonClick}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          <div className="form-container-body-row">
            <RadioInput
              name="business-goal"
              id="matching-criteria-5"
              data={BusinessGoal}
              incomingValue={this.state.value}
              onChange={this.handleRadioInputOnChange}
            />
          </div>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default withRouter(Goal);
